<template>
	<div class="container l-cnotices" style="padding:5px 10px;background:var(--border);border-radius:5px;">

		<div class="flex-wrap flex-between" style="width:100%;height:30px;font-weight:bold;">
      <div class="flex-wrap"><BaseIcon icon="md-apps" style="margin-right:5px" />
	  <template v-for="(p,i) in panels">
		<div class="flex-wrap" :key="p.key">
		<Badge :dot="p.new"  ><a @click="selected = p.key;getData(true)" :style="`color:${selected==p.key?'var(--primary)':'var(--subtext2)'}`">{{ p.name }}</a></Badge>
		<Divider type="vertical" v-if="i !== panels.length" />
		</div>
	  </template>
	</div>
	<a @click="RouteToApp"><BaseIcon icon="ios-more" :size="20" /></a>
    </div>
		<div style="
	border-radius: 2px;
	height:calc(100% - 30px);
	">
		<BaseLoading v-if="loading"> </BaseLoading>
    <BaseEmpty v-else-if="items.filter(v=>v.id).length == 0" msg="这个板块还没有内容上传" />
		<template v-else>
			<template v-for="(item,i) in items">
				<div
					:key="'notice_'+i+'_' + item.id"
					class="flex-wrap flex-between flex-line notice-item"
					:style="`${item.id?'':'height:35px;border:none;'};height:45px;`"

					@click="handleOpen(item)"
				>

					<div class="flex-wrap title" style="overflow:hidden;">


						 <div style="flex-grow:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--primary)" :title="item.name">{{ item.name }}

						<div style="font-size:12px;color:var(--text3);white-space:nowrap;flex-shrink:0;" v-if="item.desc">{{ item.desc}}</div>

						 </div>
						 <BaseNew style="flex-shrink:0;margin-left:5px;"  v-if="item.created_at && moment(item.created_at).isAfter(moment().subtract(3,'days'))" ></BaseNew>
					</div>

					<div v-if="item.date || item.created_at" style="flex-shirnk:0;font-size:14px;color:var(--success);margin-left:10px;">
						{{ moment(item.date || item.created_at).format("MM/DD") }}
					</div>
				</div>
			</template>
		</template>
		</div>
	</div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      loading: false,
      items: [],
      selected: 'ai',
    };
  },
  computed: {
    panels() {
      return [{
        key: 'ai',
        name: 'AI - 常用网站分享',
      }];
    },
  },
  created() {
    this.getData();
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    getData(forced=false) {
      if (forced || this.items.length == 0) {
        setTimeout(() => {
          // this.loading = true;
          // this.$api
          // 	.get(`articles?t=${this.selected || "notice"}`)
          // 	.then((res) => {
          // 		let items = res.data.data;
          // 		if(items.length < 6){
          // 			for(let i=0;i<6-items.length;i++){
          // 				items.push({})
          // 			}
          // 		}
          // 		this.items = items
          // 	})
          // 	.finally(() => {
          // 		this.loading = false;
          // 	});
          this.items = [{
            id: 1,
            name: '天宫智能体AI',
            link: 'https://www.tiangong.com',
            desc: '复杂任务处理，可用于做数据调研',
          }, {
            id: 2,
            name: '豆包AI',
            link: 'https://www.doubao.com',
            desc: '字节跳动出品，支持图片识别,上下文长度:128k',
          }, {
            id: 3,
            name: '文心一言',
            link: 'https://www.wenxin.com',
            desc: '百度出品，上下文长度:128k',
          }, {
            id: 4,
            name: '腾讯元宝',
            link: 'https://www.yuanbao.com',
            desc: '腾讯出品，上下文长度:128k',
          }, {
            id: 5,
            name: 'Deepseek',
            link: 'https://www.deepseek.com',
            desc: '深度求索出品，上下文长度:128k',
          }, {
            id: 6,
            name: 'Kimi',
            link: 'https://www.kimi.com',
            desc: '月之暗面出品，上下文长度:128k',
          }];
        }, 500);
      }
    },
    RouteToApp() {
      const base_url = '/core/ai-examples';
      const url = base_url;
      this.$store.commit('session/push', {
        name: 'AI应用',
        icon: 'md-star',
        url,
        base_url,
      });
      this.RouteTo(url, false);
    },
    handleOpen(item) {
      if (!item || !item.id) {
        return;
      }
      this.RouteTo(item.link, true);
    },
  },
};
</script>

  <style lang="less">
.l-cnotices {
	overflow: hidden;
	position: relative;

}

.notice-item{
	padding: 7px;
            width:100%;
						font-size: 14px;
						border-bottom: 1px dashed var(--border);
						cursor: pointer;

						.title{
							color:var(--text2)
						}
}
.notice-item:hover{
	filter:brightness(1.1);
	transition: all 0.5s;
	border-color:var(--primary);

	.title{
		color:var(--primary);
	}
}
</style>
